import { Link } from 'react-router-dom';
import styled from 'styled-components';
import { LINKS, RouterPaths } from '../../../app/appConstants';
import { useLangContext } from '../../../providers/LangProvider/LangProviderContext';
import LandingArrow from './LandingArrow';

const LandingFooterStyled = styled.footer``;

function LandingFooter() {
    const { getLangPath } = useLangContext();

    return (
        <LandingFooterStyled className="wrap partner-footer">
            <div className="footer-top-row">
                <Link className="logo" to={{ pathname: RouterPaths.main, hash: '#audience' }}>
                    jetvix
                    <span>{getLangPath('landing.header.partners')}</span>
                </Link>
                <div className="footer-center-links">
                    <nav className="legal-links" aria-label="Legal documents">
                        <a href={LINKS.affiliateAgreementDoc} target="_blank" rel="noopener noreferrer">
                            {getLangPath('landing.footer.agreement')}
                        </a>
                        <a href={LINKS.privacyPolicyDoc} target="_blank" rel="noopener noreferrer">
                            {getLangPath('landing.footer.privacy')}
                        </a>
                    </nav>
                    <div className="footer-external">
                        <a href="https://jetvix.com" target="_blank" rel="noopener noreferrer">
                            jetvix.com
                            {' '}
                            <LandingArrow/>
                        </a>
                        <a href="https://t.me/jetvix_bot" target="_blank" rel="noopener noreferrer">
                            @jetvix_bot
                            {' '}
                            <LandingArrow/>
                        </a>
                    </div>
                </div>
                <div className="footer-company">
                    <div className="company-balanced-line">
                        <strong>Jet Corp LLC</strong>
                        <span>Ginger Village, Belmont,</span>
                    </div>
                    <address>Kingstown, St. Vincent and the Grenadines</address>
                    <span className="company-copyright">© 2023-2026</span>
                </div>
            </div>
            <p className="legal-risk">{getLangPath('landing.footer.risk')}</p>
        </LandingFooterStyled>
    );
}

export default LandingFooter;
